import { dashboardApiURL } from "API/urls/dashboard.api";
import { axiosInstance } from "configs/axios";

export const taskActionApi = async ({ commentData, ids, action }) => {
  try {
    const response = await axiosInstance.post(dashboardApiURL.taskAction, {
      ids,
      action,
      commentData,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
